export default __webpack_public_path__ + "static/documents-hero-image-683102ec68150a22fd6ad7112fc5ee3d.webp";